import { render, staticRenderFns } from "./DynamicDropdown.vue?vue&type=template&id=3bdda1a3"
import script from "./DynamicDropdown.vue?vue&type=script&lang=js"
export * from "./DynamicDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports